import { type RouteRecordRaw } from 'vue-router'

export const ROUTE_AUTH_FAIL = 'auth-akto-fail'
export const PATH_AUTH_FAIL = `/${ROUTE_AUTH_FAIL}`

export const authRoutesAkto: Array<RouteRecordRaw> = [
  {
    path: PATH_AUTH_FAIL,
    name: ROUTE_AUTH_FAIL,
    component: () => import('../views/FailView.vue'),
  },
]
